import { MBModal } from '../MBModal';
import { MBModalFromBottomProps } from '../props';

/*
    For now we show the default modal on web. To see what this
    modal is, see Storybook for the native examples.
*/
export function MBModalFromBottom(props: MBModalFromBottomProps) {
  return <MBModal {...props} />;
}
